var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetaAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-9670054d-9ec9-4aaa-8b7b-2c934b3973a5",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-acea98a0-faff-404e-ad41-2e37cc24e292 {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-acea98a0-faff-404e-ad41-2e37cc24e292",
    d: "M16,23.35c-4,0-7.25-3.25-7.25-7.25s3.25-7.25,7.25-7.25,7.25,3.25,7.25,7.25-3.25,7.25-7.25,7.25ZM16,10.83c-2.91,0-5.27,2.36-5.27,5.27s2.36,5.27,5.27,5.27,5.27-2.36,5.27-5.27-2.36-5.27-5.27-5.27Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaAi);
export default __webpack_public_path__ + "static/media/MetaAI.c3a0cf8b9d2c2dfddc5841ed37543fb6.svg";
export { ForwardRef as ReactComponent };